import React, { useState, useEffect } from "react";
  import { useNavigate } from "react-router-dom";
import "./FAQs.css";

const FAQs = () => {
 const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What is CQC compliance?",
      answer:
        "CQC compliance means meeting the standards set by the Care Quality Commission for safe, effective, responsive, caring, and well-led healthcare services.",
    },
     {
      question: "Who needs CQC registration?",
      answer:
        "Social & healthcare providers offering regulated activities in England must register with the Care Quality Commission before legally delivering services to patients.",
    },
     {
      question: "How long does CQC registration take?",
      answer:
        "Registration times vary depending on application quality and service type, but many providers receive decisions within several weeks or months, 4 - 6 months is a realistic average.",
    },
     {
      question: "How can CQC consultancy help my service?",
      answer:
        "A consultancy provides guidance on policies, audits, governance, inspections, and compliance systems to help services meet regulatory standards confidently.",
    },
     {
      question: "What are the five CQC key questions?",
      answer:
        "The Care Quality Commission assesses whether services are safe, effective, caring, responsive, and well-led during inspections and compliance reviews.",
    },
     {
      question: "What policies are required for CQC?",
      answer:
        "Care providers typically need safeguarding, consent and capacity, infection control, recruitment, complaints, medication, and governance policies tailored to their specific services.",
    },
     {
      question: "Do all providers need compliance support?",
      answer:
        "All providers, big and small, can often benefit from expert guidance to establish compliant systems, reduce risks, and prepare confidently for inspections and audits.",
    },
     {
      question: "Why is good governance important for CQC?",
      answer:
        "Strong governance helps providers manage risks, improve care quality, maintain accurate records, and demonstrate continuous improvement to inspectors.",
    },
     {
      question: "What happens during a CQC inspection?",
      answer: "Inspectors review records, interview staff and patients, observe care delivery, and assess whether services meet required quality standards consistently.",
    },
     {
      question: "Can you help prepare for a CQC inspection?",
      answer:
        "Yes, compliance consultants conduct mock inspections, identify gaps, improve documentation, and support teams before official inspection visits occur.",
    },

   
  ];

     const navigate = useNavigate();
  const handleSeeMore = () => {
    navigate("/", {
      state: { scrollToContact: true },
    });
  };

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // Open page on top
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

   
 

  return (
    <div className="FAQs">
      <div className="FAQs-card">
        <h1 className="FAQs-title">
          Consultancy backed by Experience
        </h1>
        <p className="FAQs-pera">
          At Total Care Advisory, we deliver trusted consultancy backed by
          real-world experience. With a practical understanding of the care
          sector, we support providers with clear guidance, tailored solutions,
          and expert insight to help navigate challenges, improve standards, and
          achieve lasting success.
        </p>
      </div>
      
     <section className="faq-container">
      <h2 className="faq-text">Frequently asked questions</h2>
      <p className="faq-pera">It all began with a simple idea fueled by a deep passion. As a small business, we pride ourselves on personal attention and dedication to every detail. Our approach is rooted in quality and integrity, ensuring that everything we do reflects our commitment to excellence.</p>

      {faqs.map((faq, index) => (
        <div
          key={index}
          className={`faq-item ${
            activeIndex === index ? "active" : ""
          }`}
        >
          <button
            className="faq-question"
            onClick={() => toggleFAQ(index)}
          >
            {faq.question}
            <span className="faq-icon">+</span>
          </button>

          <div className="faq-answer">
            <p>{faq.answer}</p>
          </div>
        </div>
      ))}
    </section>
        <section className="Confidence">
         <h1 className="Confidence-title">Confidence in Compliance</h1>
          <p className="Confidence-pera">At Total Care Advisory, our clients’ success is our success. We work alongside care providers to
             build stronger, safer, and more compliant organisations that deliver lasting impact. Through expert guidance and real-world 
             experience, we help shape better care companies for the future ,supporting the people and communities across the UK who rely on
              quality care every day</p>
          <div className="btn-Confidence">
            <button className="OurServices-btn" onClick={handleSeeMore}>Let's get started</button>
         </div>
        </section>
    </div>
  );
};

export default FAQs;